import React, { useState } from "react";

const Player = (props) => {
  const { isMobile, playingMix, drawerMix, setDrawerMix, setDrawerOpen, playerOpen, setPlayerOpen } = props;

  


  return (
    <section className={`player__wrapper ${playingMix ? "now-playing" : ""} ${playerOpen ? "active" : ""}`} onClick={(e)=>{
        e.stopPropagation();
        setPlayerOpen(prev=> !prev);
      }}>
      <div className={`player__close ra__button`} onClick={(e)=>{
        e.stopPropagation();
        setPlayerOpen(prev=> !prev);
      }}>
        {playerOpen?<span className="ra__arrow">&darr;</span>
        :<span className="ra__arrow">&uarr;</span>}
        
      </div>

      <div className={`player__header-wrapper`}>
        {!isMobile?'Now playing:':''} {playingMix?.title}

        <div className="player__waveform-wrapper">
            <div className="player__waveform wave-1" />
            <div className="player__waveform wave-2" />
            <div className="player__waveform wave-3" />
            <div className="player__waveform wave-4" />
            <div className="player__waveform wave-5" />
        </div>

        <button
          className={`ra__button player__more-info ${drawerMix !== playingMix?('active'):''}`}
          onClick={(e) => {
            e.stopPropagation();
            setDrawerMix(playingMix);
            setDrawerOpen(true);
          }}
        >
          More Info <span className="ra__arrow">&#8599;</span>
        </button>
        
      </div>

      <div className={`player__embed-wrapper`}>
        {playingMix?(
        <iframe
          title="Player"
          width="100%"
          height="100%"
          src={`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${playingMix?.id}&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true`}
        />
        ):''}
      </div>
    </section>
  );
};

export default Player;
